import { render, staticRenderFns } from "./RouteTo.vue?vue&type=template&id=779309e6"
import script from "./RouteTo.vue?vue&type=script&lang=js"
export * from "./RouteTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports